export default __webpack_public_path__ + "static/media/divide.afed1891.svg";